import {
  CommonModule,
  DOCUMENT,
  NgIf,
  NgStyle,
  NgSwitch,
  NgSwitchCase
} from '@angular/common';
import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MatButtonToggle,
  MatButtonToggleGroup
} from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import {
  CalendarA11y,
  CalendarCommonModule,
  CalendarDateFormatter,
  CalendarDayModule,
  CalendarEventTitleFormatter,
  CalendarMonthModule,
  CalendarUtils,
  CalendarWeekModule,
  DateAdapter
} from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import moment from 'moment';
import { DateFormatPipe } from 'ngx-moment';
import { Subject } from 'rxjs';
import { DeliveryJobDetailsComponent } from '../../../dashboard/my-jobs-tile/delivery-jobs-list/delivery-job-details/delivery-job-details.component';
import { DeliveryDashboardItem } from '../../../models/deliveries/delivery-dashboard-item';
import { Delivery } from '../../../models/index';
import { CustomerNameCellComponent } from '../../ag-grid-cells/customer-name-cell.component';
import { DeliveryStatusCellComponent } from '../../ag-grid-cells/delivery-status-cell.component';
import { UserNameCellComponent } from '../../ag-grid-cells/user-name-cell.component';
import { dateComparator } from '../../helpers/DateComparator';
import { filterDateComparator } from '../../helpers/FilterDateComparator';
import { BookingItemNamePipe } from '../../pipes/booking-item-name.pipe';
import { DeliveryItemNamePipe } from '../../pipes/delivery-item-name.pipe';
import { LocationNameFromIdPipe } from '../../pipes/location-name-from-id.pipe';
import { ConfigService } from '../../services/config.service';
import { DeliveryService } from '../../services/delivery.service';
import { DeliveryJobForUser } from '../../services/user-jobs.service';
@Component({
  selector: 'delivery-list',
  templateUrl: './delivery-list.component.html',
  styleUrls: ['./delivery-list.component.scss'],
  providers: [
    DeliveryService,
    LocationNameFromIdPipe,
    CalendarUtils,
    DateFormatPipe,
    DeliveryItemNamePipe,
    BookingItemNamePipe,
    DeliveryService,

    CalendarUtils,
    DateFormatPipe,
    CalendarUtils,
    {
      provide: DateAdapter,
      useFactory: adapterFactory
    },
    CalendarA11y,
    CalendarDateFormatter,
    CalendarEventTitleFormatter
  ],
  standalone: true,
  imports: [
    FlexModule,
    MatButtonToggleGroup,
    MatButtonToggle,
    MatIcon,
    ExtendedModule,
    NgIf,
    AgGridModule,
    NgStyle,
    MatIconButton,
    MatButton,
    NgSwitch,
    NgSwitchCase,
    CommonModule,
    CalendarCommonModule,
    CalendarMonthModule,
    CalendarWeekModule,
    CalendarDayModule,
    DeliveryJobDetailsComponent
  ],
  styles: [
    `
      :host {
        flex: 1;
      }
    `
  ]
})
export class DeliveryListComponent implements OnInit {
  @Input() set deliveries(value: DeliveryJobForUser[]) {
    if (value) {
      value.sort((a, b) => {
        return new Date(a.due).getTime() - new Date(b.due).getTime();
      });
      this.deliveryItems =
        this.deliveryService.deliveriesToDashboardItems(value);
      this.calendarItems =
        this.deliveryService.deliveriesToCalendarItems(value);
      this.refresh.next();
      this.document.defaultView.setTimeout(() => {
        if (this.grid.api) {
          this.grid.api.setRowData(this.deliveryItems);
          this.grid.columnApi.autoSizeAllColumns();
        }
      });
    }
  }

  @Input() height = 200;
  @ViewChild(MatButtonToggleGroup, { static: true })
  group: MatButtonToggleGroup;

  columns: ColDef[] = [
    { headerName: 'Delivery', width: 120, field: 'delivery_id' },
    {
      headerName: 'Customer',
      cellRenderer: CustomerNameCellComponent,
      field: 'customer',
      filter: 'agTextColumnFilter',
      filterParams: {
        textFormatter: (value) => {
          return value;
        },
        caseSensitive: false,
        clearButton: true
      }
    },
    { headerName: 'Location', field: 'location' },
    {
      headerName: 'Due',
      field: 'due',
      width: 180,
      comparator: dateComparator,
      valueGetter: (params) => {
        return this.datePipe.transform(
          params.data['due'],
          ConfigService.dates.shortDateTimeFormat
        );
      },
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: filterDateComparator
      }
    },
    {
      headerName: 'Assigned To',
      field: 'allocated_to',
      cellRenderer: UserNameCellComponent
    },
    {
      headerName: 'Created',
      field: 'created',
      width: 180,
      comparator: dateComparator,
      valueGetter: (params) => {
        return this.datePipe.transform(
          params.data['created_at'],
          ConfigService.dates.shortDateTimeFormat
        );
      },
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: filterDateComparator
      }
    },
    {
      headerName: 'Items',
      field: 'itemNames',
      width: 240,
      tooltipField: 'itemNames'
    },
    { headerName: 'Type', field: 'type' },
    {
      headerName: 'Status',
      field: 'status',
      cellRenderer: DeliveryStatusCellComponent
    }
  ];

  calendarViewType = 'week';

  @ViewChild('agGrid') grid!: AgGridAngular;

  deliveryItems: DeliveryDashboardItem[] = [];
  calendarItems: any[] = [];
  refresh = new Subject<void>();
  calendarViewDate = new Date();
  calendarViewDateMoment = moment();
  selectedDelivery: Delivery;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private deliveryService: DeliveryService,
    private datePipe: DateFormatPipe
  ) {}

  ngOnInit() {
    this.group.writeValue('table');
  }

  setRowData() {
    this.grid.api.updateGridOptions({ rowData: this.deliveryItems });
  }

  changeViewDate(amount) {
    if (amount === 0) {
      this.calendarViewDate = new Date();
      return;
    }
    this.calendarViewDate = moment(this.calendarViewDate)
      .add(amount, this.calendarViewType)
      .toDate();
    this.calendarViewDateMoment = moment(this.calendarViewDate);
    this.refresh.next();
  }

  changeCalendarView(newType: string) {
    if (newType === this.calendarViewType) {
      return;
    }
    this.calendarViewType = newType;
  }

  selectRow(row) {
    if (!row.node.selected) {
      return;
    }
    if (
      this.selectedDelivery &&
      this.selectedDelivery.id === row.data.delivery.id
    ) {
      return;
    }
    this.selectedDelivery = row.data.delivery;
  }

  deselect() {
    this.selectedDelivery = null;
    if (this.grid.api) {
      this.grid.api.deselectAll();
    }
  }

  selectedNodeUpdated(delivery: DeliveryJobForUser) {
    let dashboardItem = this.deliveryService.deliveriesToDashboardItems([
      delivery
    ])[0];
    let selected = this.grid.api.getSelectedNodes();
    if (selected[0]) {
      selected[0].setData(dashboardItem);
    }
  }

  selectDelivery(delivery: any) {
    this.selectedDelivery = delivery.event.item;
  }
}
